"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextTokenService = void 0;
var tslib_1 = require("tslib");
var http_1 = require("@wix/ambassador-social-groups-v2-context-token/http");
var types_1 = require("@wix/ambassador-social-groups-v2-context-token/types");
var BaseApi_1 = require("../BaseApi");
var ContextTokenService = /** @class */ (function (_super) {
    tslib_1.__extends(ContextTokenService, _super);
    function ContextTokenService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contextTokens = {};
        return _this;
    }
    ContextTokenService.prototype.getContextToken = function (groupId) {
        var contextToken = this.contextTokens[groupId];
        return Promise.resolve(contextToken || this.requestContextToken(groupId));
    };
    ContextTokenService.prototype.getContextTokens = function (groupIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var idsToRequest, storedTokens;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idsToRequest = groupIds.filter(function (id) { return !_this.contextTokens[id]; });
                        if (!idsToRequest.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.requestContextTokens(idsToRequest)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, groupIds.map(function (id) { return _this.contextTokens[id]; })];
                    case 2:
                        storedTokens = groupIds
                            .filter(function (id) { return !!_this.contextTokens[id]; })
                            .map(function (id) { return _this.contextTokens[id]; });
                        return [2 /*return*/, Promise.resolve(storedTokens)];
                }
            });
        });
    };
    ContextTokenService.prototype.requestContextToken = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestContextTokens([groupId])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.contextTokens[groupId]];
                }
            });
        });
    };
    ContextTokenService.prototype.requestContextTokens = function (groupIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tokens;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(groupIds.map(function (groupId) {
                            return _this.getHTTPClient().request(http_1.getContextToken({
                                groupId: groupId,
                                services: [types_1.ProtectedService.FEED],
                            }));
                        }))];
                    case 1:
                        tokens = _a.sent();
                        this.contextTokens = tokens.reduce(function (acc, token) {
                            var _a;
                            return (tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[token.data.token.groupId] = token.data.token.value, _a)));
                        }, {});
                        return [2 /*return*/, this.contextTokens];
                }
            });
        });
    };
    return ContextTokenService;
}(BaseApi_1.BaseApi));
exports.ContextTokenService = ContextTokenService;
//# sourceMappingURL=context-token.service.js.map